import { STATUS_LABELS, type SubtitleStatus } from '@/types/work';

interface StatusBadgeProps {
  status: SubtitleStatus;
  className?: string;
}

export default function StatusBadge({ status, className = '' }: StatusBadgeProps) {
  const isDone = status === 'completed';
  const tone = isDone
    ? 'bg-accent-500/90 text-background-50'
    : 'bg-primary-700/90 text-background-50';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-medium leading-none whitespace-nowrap ${tone} ${className}`}
    >
      <i className={isDone ? 'ri-check-line' : 'ri-loader-4-line'}></i>
      {STATUS_LABELS[status]}
    </span>
  );
}